// A trial reads "Trial" in the account; people know it as the Gitcha Pro trial.
export const cancelPlanLabel = (planName) => (planName === "Trial" ? "Gitcha Pro trial" : `${planName} plan`);
